import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icons from '../components/Icons';

export default function GuidePage() {
  const navigate = useNavigate();
  return (
    <div className="custom-scroll page-enter" style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'var(--bg)', zIndex: 9999, overflowY: 'auto' }}>
      
      <button onClick={() => navigate(-1)} style={{ position: 'absolute', top: 30, right: 30, width: 44, height: 44, borderRadius: '50%', background: 'rgba(255,255,255,0.05)', color: 'var(--t2)', border: '1px solid rgba(255,255,255,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', zIndex: 10 }}>
        <Icons.X sz={20} />
      </button>

      <div style={{ maxWidth: 800, margin: '0 auto', padding: '80px 20px', color: 'var(--t2)', lineHeight: 1.6 }}>
        <div style={{ textAlign: 'center', marginBottom: 50 }}>
          <h1 style={{ fontSize: 36, color: 'var(--t1)', marginBottom: 12, fontWeight: 800 }}>User Guide</h1>
          <p style={{ fontSize: 16, color: 'var(--t3)', maxWidth: 500, margin: '0 auto' }}>
            Master the art of generative AI. Step-by-step documentation for all features in aiField Studio.
          </p>
        </div>

        <div style={{ background: 'var(--bg2)', padding: 30, borderRadius: 16, border: '1px solid var(--b2)', marginBottom: 30 }}>
          <h2 style={{ fontSize: 22, color: 'var(--t1)', marginBottom: 12, display: 'flex', alignItems: 'center', gap: 8 }}><Icons.Sparkle sz={20} /> Prompt Anatomy</h2>
          <p style={{ fontSize: 14, color: 'var(--t3)', marginBottom: 16 }}>
            A good prompt clearly separates subject, environment, lighting, and style.
          </p>
          <div style={{ background: 'rgba(0,0,0,0.3)', padding: 16, borderRadius: 8, borderLeft: '3px solid #22d3ee', fontFamily: 'monospace', fontSize: 13, color: 'var(--t2)' }}>
            <span style={{ color: '#f472b6' }}>[Subject: A futuristic cyberpunk samurai]</span>, 
            <span style={{ color: '#38bdf8' }}> [Environment: standing on a neon-lit rooftop in Neo-Tokyo raining heavily]</span>, 
            <span style={{ color: '#fbbf24' }}> [Lighting: cinematic rim lighting from neon signs]</span>, 
            <span style={{ color: '#a78bfa' }}> [Style: Unreal Engine 5 render, highly detailed, photorealistic]</span>
          </div>
          <div style={{ marginTop: 16, textAlign: 'right' }}>
            <button
              onClick={() => navigate('/promptbook')}
              style={{
                background: 'rgba(34, 211, 238, 0.1)',
                border: '1px solid rgba(34, 211, 238, 0.3)',
                color: '#22d3ee',
                padding: '8px 16px',
                borderRadius: '8px',
                fontSize: '13px',
                fontWeight: 'bold',
                cursor: 'pointer',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                transition: 'all 0.2s'
              }}
              onMouseEnter={e => e.currentTarget.style.background = 'rgba(34, 211, 238, 0.2)'}
              onMouseLeave={e => e.currentTarget.style.background = 'rgba(34, 211, 238, 0.1)'}
            >
              📖 Advanced Promptbook
            </button>
          </div>
        </div>

        <div style={{ background: 'var(--bg2)', padding: 30, borderRadius: 16, border: '1px solid var(--b2)', marginBottom: 30 }}>
          <h2 style={{ fontSize: 22, color: 'var(--t1)', marginBottom: 12, display: 'flex', alignItems: 'center', gap: 8 }}><Icons.Img sz={20} /> Visual References</h2>
          <p style={{ fontSize: 14, color: 'var(--t3)', marginBottom: 16 }}>
            You can upload up to 4 images to guide the structure, character, and styling of a generation. Models like Flux 2 Max heavily weigh Visual References.
          </p>
          <ul style={{ fontSize: 14, paddingLeft: 20, color: 'var(--t3)' }}>
            <li style={{ marginBottom: 8 }}><strong>Character consistency:</strong> Upload face shots of a subject.</li>
            <li style={{ marginBottom: 8 }}><strong>Style transfer:</strong> Upload an artwork or drawing whose aesthetic you want applied.</li>
            <li style={{ marginBottom: 8 }}><strong>Pose composition:</strong> Use simple line drawings as input for advanced rendering.</li>
          </ul>
        </div>
        
        <div style={{ background: 'var(--bg2)', padding: 30, borderRadius: 16, border: '1px solid var(--b2)' }}>
          <h2 style={{ fontSize: 22, color: 'var(--t1)', marginBottom: 12, display: 'flex', alignItems: 'center', gap: 8 }}><Icons.Vid sz={20} /> Multi-Shot Video</h2>
          <p style={{ fontSize: 14, color: 'var(--t3)', marginBottom: 16 }}>
            Kling 3.0 allows generating complex clips spanning seamlessly across up to 5 shots.
          </p>
          <ul style={{ fontSize: 14, paddingLeft: 20, color: 'var(--t3)' }}>
            <li style={{ marginBottom: 8 }}>You can assign a customized duration to each shot (from 5s up to 12s).</li>
            <li style={{ marginBottom: 8 }}>Write individual descriptions for each multi-shot stage to orchestrate fluid camera movements and sequential actions.</li>
          </ul>
        </div>

      </div>
    </div>
  );
}
